export default "__VITE_ASSET__bdd1a46c__"